import {useConsent, useHeap} from '@newsela/snitch';
import {connect} from 'react-redux';

import {DATAGRAIL_PERFORMANCE_CATEGORY} from 'static/three-oh/src/datagrailIntegration/config';
import {getUser} from 'static/three-oh/src/modules/selectors/userSelectors';

// Sentinel passed when the user has not granted performance consent. snitch's
// useHeap short-circuits identification on is_authenticated: false; the other
// required fields are filled with zero-value placeholders.
const NO_CONSENT_HEAP_USER = {
  is_authenticated: false,
  unique_id: 0,
  id: 0,
  licenses: [],
  date_joined: '',
};

const HeapTrackingContainer = ({user}) => {
  const hasConsent = useConsent(DATAGRAIL_PERFORMANCE_CATEGORY);

  /**
   * Shaped object of user properties necessary to send to heap
   */
  const heapUser = hasConsent
    ? {
        unique_id: user?.id,
        licenses: user?.licenses,
        classroom_grade_levels: user?.classroom_grade_levels,
        date_joined: user?.date_joined,
        id: user?.id,
        email: user?.email,
        is_demo: user?.is_demo,
        is_staff: user?.is_staff,
        is_authenticated: user?.is_authenticated,
        features: user?.features,
        student: user?.student,
        teacher: user?.teacher,
        district_admin: user?.district_admin,
        principal: user?.principal
      }
    : NO_CONSENT_HEAP_USER;
  useHeap(heapUser);
  return null;
};

const mapStateToProps = (state) => {
  return {
    user: getUser(state),
  };
};

export default connect(mapStateToProps)(HeapTrackingContainer);
